import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import(/* webpackChunkName: "publicInfoHome" */ '@/pages/publicInfo/components/Home')

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			component: Home,
			name:'home'
		},
	],
	scrollBehavior(to, from, savedPosition) {
		// console.log(to)
		return { x: 0, y: 0 }
	}
})



// WEBPACK FOOTER //
// ./src/pages/publicInfo/router/index.js